import type { FunctionComponent } from "react";

import { tracking } from "shared/data";

import { ArticleMoreStories } from "scmp-app/components/article/article-more-stories";
import { hasPostiesQuiz } from "scmp-app/components/article/article-render/posties/helpers";
import { page as postiesKidsPage } from "scmp-app/pages/posties/kids";
import type { articleFooterArticle$data } from "scmp-app/queries/__generated__/articleFooterArticle.graphql";
import type { articleMoreStoriesArticle$key } from "scmp-app/queries/__generated__/articleMoreStoriesArticle.graphql";

import FooterPeterAndPippaQuiz from "./footer-peter-and-pippa-quiz.png";
import FooterPeterAndPippa from "./footer-peter-and-pippa.png";
import {
  ArticleMoreStoriesContainer,
  ButtonLink,
  ButtonText,
  Container,
  StyledFooterImageContainer,
  StyledFooterImageContainerForQuiz,
  StyledFooterPeterAndPippa,
  StyledFooterPeterAndPippaImageContainer,
  StyledFooterPeterAndPippaImageContainerForQuiz,
} from "./styles";

export type Props = {
  className?: string;
  reference: articleMoreStoriesArticle$key;
};

export const PostiesArticleFooter: FunctionComponent<Props> = ({ className, reference }) => {
  const { pathname, query } = postiesKidsPage.route({});

  const postiesArticleFooterQueryParameters = {
    module: tracking.module.BackToHomepage,
    pgtype: tracking.pageType.ArticlePosties,
  };

  const hasQuiz = hasPostiesQuiz(reference as articleFooterArticle$data);

  return (
    <Container className={className}>
      <ArticleMoreStoriesContainer>
        <ArticleMoreStories reference={reference} />
      </ArticleMoreStoriesContainer>
      <ButtonLink pathname={pathname} query={{ ...query, ...postiesArticleFooterQueryParameters }}>
        <ButtonText>BACK TO HOMEPAGE</ButtonText>
      </ButtonLink>
      {hasQuiz ? (
        <StyledFooterImageContainerForQuiz>
          <StyledFooterPeterAndPippaImageContainerForQuiz>
            <StyledFooterPeterAndPippa src={FooterPeterAndPippaQuiz.src} />
          </StyledFooterPeterAndPippaImageContainerForQuiz>
        </StyledFooterImageContainerForQuiz>
      ) : (
        <StyledFooterImageContainer>
          <StyledFooterPeterAndPippaImageContainer>
            <StyledFooterPeterAndPippa src={FooterPeterAndPippa.src} />
          </StyledFooterPeterAndPippaImageContainer>
        </StyledFooterImageContainer>
      )}
    </Container>
  );
};

PostiesArticleFooter.displayName = "PostiesArticleFooter";
